export const EMPTY_BRANCH = {
  name: "",
  name_ar: "",
  code: "",
  address: "",
  latitude: "",
  longitude: "",
  geofence_radius_m: 50,
  tz_offset_minutes: 240,
  timezone_name: "",
  work_start: "09:00",
  work_end: "17:00",
  grace_minutes: 10,
  work_days: [0, 1, 2, 3, 4],
  weekend_days: [5, 6],
  allow_weekend_work: false,
  weekend_counts_as_overtime: true,
  accounting_standard: "IFRS",
  primary_currency: "USD",
  vat_enabled: false,
  vat_rate: 0,
  payroll: {
    payroll_day: 28,
    allow_early_announce: null,
    deduct_absence: true,
    absence_days_per_day: 1,
    salary_hold_enabled: true,
    salary_hold_absence_days: 3,
    deduct_late: true,
    late_free_minutes: 0,
    advances_allowed: true,
    advance_max_percent: 50,
    advance_max_amount: "",
    advance_max_repayment_months: 6,
    resignation_notice_days: 30,
    end_of_service_note: "",
    currency: "AED",
  },
  leave: {},
  attendance: {},
  contact: { logo_url: "", phones: [], email: "", website: "" },
  legal: { trn: "", trade_license_no: "", license_expiry: "", license_authority: "", legal_address: "" },
  entity_type: "branch",
  excluded_holiday_ids: [],
  qr_required: false,
  calendar_system: "auto",
  address_ar: "",
  address_en: "",
};

export const RADIUS_OPTIONS = [30, 50, 100, 250, 500];
export const DAY_KEYS = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];

const num = (v, fallback = 0) => (v === "" || v === null || v === undefined ? fallback : Number(v));

export const toBranchPayload = (form) => {
  const body = {
    ...form,
    latitude: Number(form.latitude),
    longitude: Number(form.longitude),
    geofence_radius_m: num(form.geofence_radius_m, 50),
    grace_minutes: num(form.grace_minutes, 0),
    tz_offset_minutes: num(form.tz_offset_minutes, 240),
    payroll: {
      ...form.payroll,
      payroll_day: num(form.payroll.payroll_day, 28),
      advance_max_percent: num(form.payroll.advance_max_percent, 0),
      advance_max_amount: form.payroll.advance_max_amount === "" ? null : Number(form.payroll.advance_max_amount),
      advance_max_repayment_months: num(form.payroll.advance_max_repayment_months, 6),
      resignation_notice_days: num(form.payroll.resignation_notice_days, 30),
    },
    contact: { ...form.contact, phones: (form.contact.phones || []).filter(Boolean) },
    leave: Object.fromEntries(
      Object.entries(form.leave || {}).filter(([, v]) => v !== "" && v !== null && v !== undefined)
    ),
    attendance: Object.fromEntries(
      Object.entries(form.attendance || {}).filter(([, v]) => v !== "" && v !== null && v !== undefined)
    ),
  };
  delete body.id;
  delete body.company_id;
  return body;
};
